export default {
  nav: {
    home: 'Forside',
    categories: 'Kategorier',
    articles: 'Artikler',
    spreadsheet: 'Regneark',
    shoppingGuide: 'Indkøbsguide',
    review: 'Anmeldelse',
    shipping: 'Forsendelse',
    coupon: 'Kupon',
    language: 'Sprog',
  },
  footer: {
    about: 'Om AllChinaBuy Spreadsheet',
    links: 'Hurtige links',
    legal: 'Juridisk',
    privacy: 'Privatlivspolitik',
    terms: 'Brugsbetingelser',
    disclaimer: 'Ansvarsfraskrivelse',
    copyright: 'AllChinaBuy Spreadsheet. Alle rettigheder forbeholdes.',
    description: 'En uafhængig informationsressource til at hjælpe købere med at researche produkter, sælgere, forsendelse og kvalitetskontrol før bestilling.',
  },
  common: {
    readMore: 'Læs mere',
    explore: 'Udforsk',
    buyNow: 'Køb nu',
    continueToMain: 'Fortsæt til hovedhjemmesiden',
    search: 'Søg',
    breadcrumbHome: 'Forside',
    close: 'Luk',
    open: 'Åbn',
  },
};